// extracted by mini-css-extract-plugin
export var articleWrapper = "ArticleCard-module--articleWrapper--Zg4gp";
export var blue = "ArticleCard-module--blue--hGq-r";
export var card = "ArticleCard-module--card--MwwK0";
export var count = "ArticleCard-module--count--uQR2a";
export var green = "ArticleCard-module--green--zK9iS";
export var iconWrapper = "ArticleCard-module--iconWrapper--Cs13Z";
export var list = "ArticleCard-module--list--hvwOF";
export var orange = "ArticleCard-module--orange--80qcJ";
export var wrapper = "ArticleCard-module--wrapper--rlk1z";